import type { TenantBrandTheme } from "../core/types.ts";

export function toAntdMobileTheme(theme: TenantBrandTheme): Record<string, string> {
  return {
    "--adm-color-primary": theme.primary,
    "--adm-color-text": theme.primary,
    "--adm-color-background": '#ffffff',
    "--adm-color-box": theme.secondary,
    "--adm-radius-s": `${theme.radii.sm}px`,
    "--adm-radius-m": `${theme.radii.md}px`,
    "--adm-radius-l": `${theme.radii.lg}px`,
    "--adm-font-family": theme.fontFamily,
  };
}

export function applyAntdMobileTheme(
  variables: Record<string, string>,
  root: HTMLElement = document.documentElement
): void {
  Object.entries(variables).forEach(([key, value]) => {
    root.style.setProperty(key, value);
  });
}
